/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_Units {
    Millimeter = 10,
    Centimeter = 20,
}
